"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * DataTableView ist die tabellarische Ansicht für die Entity
 *
 */
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_i18next_1 = require("react-i18next");
var styles_1 = require("@mui/styles");
var material_1 = require("@mui/material");
var MoreVert_1 = __importDefault(require("@mui/icons-material/MoreVert"));
var ViewWeek_1 = __importDefault(require("@mui/icons-material/ViewWeek"));
var VisibilityOff_1 = __importDefault(require("@mui/icons-material/VisibilityOff"));
var PushPin_1 = __importDefault(require("@mui/icons-material/PushPin"));
var ArrowDownward_1 = __importDefault(require("@mui/icons-material/ArrowDownward"));
var ArrowUpward_1 = __importDefault(require("@mui/icons-material/ArrowUpward"));
var commonTypes_1 = require("../../shared/types/commonTypes");
var crude_selector_1 = require("../../store/crude/crude.selector");
var crudeActions = __importStar(require("../../store/crude/crude.actions"));
var crude_actions_1 = require("../../store/crude/crude.actions");
var DataTableRow_1 = __importDefault(require("../../screens/DataTableView/DataTableRow"));
var DataTableCell_1 = __importDefault(require("../../screens/DataTableView/DataTableCell"));
var styles_2 = require("@mui/material/styles");
var isListLevelAvailable_1 = __importDefault(require("../../shared/util/isListLevelAvailable"));
var isEditLevelAvailable_1 = __importDefault(require("../../shared/util/isEditLevelAvailable"));
var AddButtonComponent_1 = __importDefault(require("../../shared/components/CrudeComponents/AddButtonComponent"));
var CrudeDialogComponent_1 = __importDefault(require("../../shared/components/CrudeComponents/CrudeDialogComponent"));
var DataEditView_1 = __importDefault(require("../DataEditView/DataEditView"));
var getCrudeEntityColumns_1 = __importDefault(require("../../shared/util/getCrudeEntityColumns"));
var getPinPosition_1 = __importDefault(require("../../shared/util/getPinPosition"));
var system_1 = require("@mui/system");
var Search_1 = __importDefault(require("@mui/icons-material/Search"));
var SwitchComponent_1 = __importDefault(require("../../shared/components/FormComponents/SwitchComponent"));
var ButtonComponent_1 = __importDefault(require("../../shared/components/FormComponents/ButtonComponent"));
var getDefaultTableFilterSettings_1 = __importDefault(require("../../defaults/getDefaultTableFilterSettings"));
var useStyles = styles_1.makeStyles(function (theme) { return ({
    table: {
        '& .MuiTableCell-head': {
            backgroundColor: theme.palette.background.paper,
            fontWeight: 700,
            padding: theme.spacing(2),
        },
        '& .MuiTableCell-root': {
            borderBottom: 'none',
        },
    },
    cell: {
        backgroundColor: 'inherit',
    },
    headerCell: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
    },
    moreIcon: {
        color: theme.palette.grey.A400,
        height: '0.7em',
        cursor: 'pointer',
    },
    columnHeaderMenu: {
        position: 'absolute',
        zIndex: 1000,
        width: '200px',
    },
    manageColumnMenu: {
        position: 'absolute',
        zIndex: 1000,
        width: '350px',
    },
    paper: {
        fontSize: theme.typography.caption.fontSize,
    },
    columnHeaderMenuEntry: {
        cursor: 'pointer',
        padding: '10px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '&:hover': {
            backgroundColor: theme.palette.background.paper,
            filter: 'brightness(95%)',
        },
    },
    disabledHeaderMenuEntry: {
        cursor: 'default',
        color: theme.palette.grey.A400,
        '&:hover': {
            backgroundColor: theme.palette.background.paper,
            filter: 'brightness(100%)',
        },
    },
    columnHeaderMenuEntryIcon: {
        width: '20%',
    },
    columnHeaderMenuEntryText: {
        width: '80%',
    },
    manageColumnsBox: {
        width: '100%',
        padding: '5px 0',
    },
    columnResizeHandle: {
        color: theme.palette.grey.A400,
        marginTop: '0px',
        fontSize: '1.3em',
        cursor: 'col-resize',
        position: 'absolute',
        right: '-18px',
    },
}); });
var DataTable = function (props) {
    var _a, _b, _c, _d;
    // TODO auslagern in Config???
    var columnHeaderMenuWidth = 200;
    var t = react_i18next_1.useTranslation().t;
    var dispatch = react_redux_1.useDispatch();
    var classes = useStyles();
    var theme = styles_2.useTheme();
    var dataDisplayMode = react_redux_1.useSelector(crude_selector_1.getDataDisplayMode);
    var crudeConfig = react_redux_1.useSelector(crude_selector_1.getCrudeConfiguration);
    var crudeSchema = react_redux_1.useSelector(crude_selector_1.getCrudeSchema);
    var appLayout = react_redux_1.useSelector(crude_selector_1.getAppLayout);
    var crudeLanguage = react_redux_1.useSelector(crude_selector_1.getLanguage);
    var crudeLabels = react_redux_1.useSelector(crude_selector_1.getCrudeLabels)[crudeLanguage];
    var storedTableFilterSettings = react_redux_1.useSelector(crude_selector_1.getTableFilterSettings);
    var crudeLicense = react_redux_1.useSelector(crude_selector_1.getCrudeLicense);
    // manage Licenses
    var configurableTableLicense = crudeLicense.configurableTable.available || false;
    var treeViewLicense = crudeLicense.treeView.available;
    var entity = props.entity;
    var entitySchema = crudeSchema && crudeSchema.find(function (entitySchema) { return entitySchema.name === entity; });
    var maxTreeViewLevel = appLayout.maxTreeViewLevel || 1;
    var _e = react_1.useState(isListLevelAvailable_1.default(treeViewLicense, dataDisplayMode, maxTreeViewLevel, props.treeViewLevel)), listLevelAvailable = _e[0], setListLevelAvailable = _e[1];
    var _f = react_1.useState(isEditLevelAvailable_1.default(props.dataViewType, maxTreeViewLevel, props.treeViewLevel)), editLevelAvailable = _f[0], setEditLevelAvailable = _f[1];
    react_1.useEffect(function () {
        props.treeViewLevel && setListLevelAvailable(isListLevelAvailable_1.default(treeViewLicense, dataDisplayMode, maxTreeViewLevel, props.treeViewLevel));
        props.treeViewLevel && setEditLevelAvailable(isEditLevelAvailable_1.default(props.dataViewType, maxTreeViewLevel, props.treeViewLevel));
    }, [props.treeViewLevel]);
    var rowsPerPageOptions = appLayout.rowsPerPageOptions || [10, 25, 50, 100];
    var storedEntityColumns = crudeSchema ? getCrudeEntityColumns_1.default(configurableTableLicense, crudeConfig, crudeSchema, entity) : [];
    var _g = react_1.useState(props.data), data = _g[0], setData = _g[1];
    var _h = react_1.useState(0), dataEntries = _h[0], setDataEntries = _h[1];
    var _j = react_1.useState(false), stickyCell = _j[0], setStickyCell = _j[1];
    var tableRef = react_1.useRef(null);
    react_1.useEffect(function () {
        props.data && setData(props.data);
        if (props.data && props.data.data) {
            setDataEntries(props.data.data.length);
        }
    }, [props.data]);
    react_1.useEffect(function () {
        if (tableRef && tableRef.current) {
            setStickyCell(tableRef.current.clientWidth > window.innerWidth);
        }
    }, [tableRef]);
    var handleChangePage = function (e, page) {
        var _a, _b;
        var newFilterSettings = __assign(__assign({}, storedTableFilterSettings), (_a = {}, _a[entity] = __assign(__assign({}, storedTableFilterSettings[entity]), (_b = {}, _b[props.treeViewLevel] = __assign(__assign({}, storedTableFilterSettings[entity][props.treeViewLevel] || getDefaultTableFilterSettings_1.default()), { page: page }), _b)), _a));
        dispatch(crudeActions.setTableFilterSettings(newFilterSettings));
    };
    var handleChangePageSize = function (e) {
        var _a, _b;
        var newFilterSettings = __assign(__assign({}, storedTableFilterSettings), (_a = {}, _a[entity] = __assign(__assign({}, storedTableFilterSettings[entity]), (_b = {}, _b[props.treeViewLevel] = __assign(__assign({}, storedTableFilterSettings[entity][props.treeViewLevel] || getDefaultTableFilterSettings_1.default()), { pageSize: Number.isInteger(Number.parseFloat(e.target.value)) ? Number.parseInt(e.target.value) : storedTableFilterSettings[entity][props.treeViewLevel].pageSize, page: 0 }), _b)), _a));
        dispatch(crudeActions.setTableFilterSettings(newFilterSettings));
    };
    var handleSortLabelClicked = function (field, order) {
        var _a, _b;
        var newOrder = order || ((storedTableFilterSettings[entity][props.treeViewLevel].orderBy === field) ? (storedTableFilterSettings[entity][props.treeViewLevel].order === commonTypes_1.Order.desc ? commonTypes_1.Order.asc : commonTypes_1.Order.desc) : storedTableFilterSettings[entity][props.treeViewLevel].order);
        var newFilterSettings = __assign(__assign({}, storedTableFilterSettings), (_a = {}, _a[entity] = __assign(__assign({}, storedTableFilterSettings[entity]), (_b = {}, _b[props.treeViewLevel] = __assign(__assign({}, storedTableFilterSettings[entity][props.treeViewLevel] || getDefaultTableFilterSettings_1.default()), { orderBy: field, order: newOrder }), _b)), _a));
        dispatch(crudeActions.setTableFilterSettings(newFilterSettings));
    };
    // D&D Columnheader
    var _k = react_1.useState(null), dragColumn = _k[0], setDragColumn = _k[1];
    var _l = react_1.useState(null), dropColumn = _l[0], setDropColumn = _l[1];
    var onDragColumnStart = function (event) {
        setDragColumn(event.currentTarget.dataset.id);
    };
    var onDragColumnOver = function (event) {
        setDropColumn(event.currentTarget.dataset.id);
    };
    var onDragColumnEnd = function (event) {
        var _a;
        var dragId = storedEntityColumns.findIndex(function (elem) { return elem.name === dragColumn; });
        var dragElement = storedEntityColumns.find(function (elem) { return elem.name === dragColumn; });
        var dropId = storedEntityColumns.findIndex(function (elem) { return elem.name === dropColumn; });
        var newTableOrder = [];
        if (dragId < dropId) {
            storedEntityColumns.map(function (elem, index) {
                if (index !== dragId) {
                    newTableOrder.push(elem);
                }
                if (index === dropId) {
                    dragElement && newTableOrder.push(dragElement);
                }
            });
        }
        if (dragElement && dragId === dropId) {
            newTableOrder.push(dragElement);
        }
        if (dragId > dropId) {
            storedEntityColumns.map(function (elem, index) {
                if (index === dropId) {
                    dragElement && newTableOrder.push(dragElement);
                }
                if (index !== dragId) {
                    newTableOrder.push(elem);
                }
            });
        }
        var newConfig = __assign({}, crudeConfig);
        var newTabs = (_a = newConfig.tabs) === null || _a === void 0 ? void 0 : _a.map(function (elem) {
            var tab = __assign({}, elem);
            if (tab.entity === entity) {
                tab.columns = newTableOrder;
            }
            return tab;
        });
        dispatch(crudeActions.setCrudeConfiguration(__assign(__assign({}, newConfig), { tabs: newTabs })));
    };
    var _m = react_1.useState(0), resizePosition = _m[0], setResizePosition = _m[1];
    var onResizeStart = function (event) {
        setResizePosition(event.pageX);
    };
    var onResizeEnd = function (event) {
        var _a;
        var newTabs = (_a = crudeConfig.tabs) === null || _a === void 0 ? void 0 : _a.map(function (elem) {
            var tab = __assign({}, elem);
            if (tab.entity === entity) {
                var newCols = (crudeSchema && getCrudeEntityColumns_1.default(configurableTableLicense, crudeConfig, crudeSchema, entity)) || [];
                var cols = newCols.map(function (elem, index) {
                    var _a, _b;
                    var col = __assign({}, elem);
                    if (event.pageX > resizePosition) {
                        // aktuelle column vergößern um Differenz
                        var diff = event.pageX - resizePosition;
                        if (col.name === actualColumn) {
                            var actualWidth = ((_a = window.document.getElementById(col.name)) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0;
                            col.columnWidth = actualWidth + diff;
                        }
                    }
                    else {
                        // aktuelle column verkleinern um Differenz
                        var diff = resizePosition - event.pageX;
                        if (col.name === actualColumn) {
                            var actualWidth = ((_b = window.document.getElementById(col.name)) === null || _b === void 0 ? void 0 : _b.offsetWidth) || 0;
                            col.columnWidth = actualWidth - diff;
                        }
                    }
                    return col;
                });
                tab.columns = cols;
            }
            return tab;
        });
        dispatch(crudeActions.setCrudeConfiguration(__assign(__assign({}, crudeConfig), { tabs: newTabs })));
    };
    // headerMenu
    var _o = react_1.useState(false), showManageColumns = _o[0], setShowManageColumns = _o[1];
    var _p = react_1.useState(false), showColumnHeaderMenu = _p[0], setShowColumnHeaderMenu = _p[1];
    var _q = react_1.useState(null), actualColumn = _q[0], setActualColumn = _q[1];
    var _r = react_1.useState(''), columnSearch = _r[0], setColumnSearch = _r[1];
    var _s = react_1.useState(), savedManagedColumnTop = _s[0], setSavedManagedColumnTop = _s[1];
    var manageColumnPageSize = 10;
    var _t = react_1.useState(0), manageColumnPage = _t[0], setManageColumnPage = _t[1];
    var handleChangeManageColumnPage = function (e, page) {
        setManageColumnPage(page);
    };
    var getPagedFilteredManageColumns = function () {
        var pagedColumns = [];
        for (var i = (manageColumnPage * manageColumnPageSize); i < ((manageColumnPage + 1) * manageColumnPageSize); i++) {
            getFilteredManageColumns()[i] && pagedColumns.push(getFilteredManageColumns()[i]);
        }
        return pagedColumns;
    };
    var getFilteredManageColumns = function () {
        var filteredColumns = [];
        var regExp = new RegExp((columnSearch || '').replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'), 'i');
        storedEntityColumns.map(function (element) {
            var _a;
            var name = columnLabels
                ? ((_a = columnLabels[element.name]) === null || _a === void 0 ? void 0 : _a.title) || element.name
                : element.name;
            if (element.name === 'crudeAction') {
                name = t('crude:actions');
            }
            if (name.match(regExp)) {
                filteredColumns.push(element);
            }
        });
        return filteredColumns;
    };
    var openColumnHeaderMenu = function (column) {
        if (column === actualColumn) {
            setShowColumnHeaderMenu(!showColumnHeaderMenu);
        }
        else {
            setShowColumnHeaderMenu(true);
        }
        setActualColumn(column);
        setShowManageColumns(false);
        setColumnSearch('');
    };
    var pinLeftActualColumn = function () {
        var _a;
        var newTablePinOrder = [];
        var pinIndex = 0;
        var pinElement = null;
        var stopPinningLeft = false;
        storedEntityColumns.forEach(function (elem, index) {
            if (elem.name === actualColumn) {
                pinElement = __assign(__assign({}, elem), { pinned: true });
            }
            if (elem.pinned && !stopPinningLeft) {
                pinIndex = index + 1;
            }
            else {
                stopPinningLeft = true;
            }
        });
        if (pinElement) {
            storedEntityColumns.map(function (elem, index) {
                // als Erstes einfügen
                if (pinIndex === 0 && index === 0) {
                    pinElement && newTablePinOrder.push(pinElement);
                    newTablePinOrder.push(elem);
                }
                // wenn nicht als erstes Element
                if (pinIndex > 0 && pinIndex - 1 === index) {
                    newTablePinOrder.push(elem);
                    pinElement && newTablePinOrder.push(pinElement);
                }
                if (pinIndex > 0 && pinIndex - 1 !== index && pinElement && pinElement.name !== elem.name) {
                    newTablePinOrder.push(elem);
                }
            });
            var newConfig = __assign({}, crudeConfig);
            var newTabs = (_a = newConfig.tabs) === null || _a === void 0 ? void 0 : _a.map(function (elem) {
                var tab = __assign({}, elem);
                if (tab.entity === entity) {
                    tab.columns = newTablePinOrder;
                }
                return tab;
            });
            dispatch(crudeActions.setCrudeConfiguration(__assign(__assign({}, newConfig), { tabs: newTabs })));
        }
        setShowColumnHeaderMenu(false);
        setActualColumn(null);
    };
    var pinRightActualColumn = function () {
        var _a;
        var newTablePinOrder = [];
        var pinIndex = 0;
        var pinElement = null;
        storedEntityColumns.map(function (elem, index) {
            if (elem.name === actualColumn) {
                pinElement = __assign(__assign({}, elem), { pinned: true });
            }
            if (!elem.pinned) {
                pinIndex = index;
            }
        });
        if (pinElement) {
            storedEntityColumns.map(function (elem, index) {
                if (pinIndex + 1 === index) {
                    pinElement && newTablePinOrder.push(pinElement);
                    newTablePinOrder.push(elem);
                }
                if (pinIndex + 1 !== index && pinElement && pinElement.name !== elem.name) {
                    newTablePinOrder.push(elem);
                }
            });
            var newConfig = __assign({}, crudeConfig);
            var newTabs = (_a = newConfig.tabs) === null || _a === void 0 ? void 0 : _a.map(function (elem) {
                var tab = __assign({}, elem);
                if (tab.entity === entity) {
                    tab.columns = newTablePinOrder;
                }
                return tab;
            });
            dispatch(crudeActions.setCrudeConfiguration(__assign(__assign({}, newConfig), { tabs: newTabs })));
        }
        setShowColumnHeaderMenu(false);
        setActualColumn(null);
    };
    var hideActualColumn = function () {
        var _a;
        var newTabs = (_a = crudeConfig.tabs) === null || _a === void 0 ? void 0 : _a.map(function (elem) {
            var tab = __assign({}, elem);
            if (tab.entity === entity) {
                var newCols = (crudeSchema && getCrudeEntityColumns_1.default(configurableTableLicense, crudeConfig, crudeSchema, entity)) || [];
                var cols = newCols.map(function (elem) {
                    var col = __assign({}, elem);
                    if (col.name === actualColumn) {
                        col.hideInTableView = true;
                    }
                    return col;
                });
                tab.columns = cols;
            }
            return tab;
        });
        dispatch(crudeActions.setCrudeConfiguration(__assign(__assign({}, crudeConfig), { tabs: newTabs })));
        setShowColumnHeaderMenu(false);
        setActualColumn(null);
    };
    var sortAscActualColumn = function () {
        actualColumn && handleSortLabelClicked(actualColumn, commonTypes_1.Order.asc);
    };
    var sortDescActualColumn = function () {
        actualColumn && handleSortLabelClicked(actualColumn, commonTypes_1.Order.desc);
    };
    var getActualHeaderColumnPosition = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (actualColumn) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            var top_1 = ((_a = window.document.getElementById(actualColumn)) === null || _a === void 0 ? void 0 : _a.offsetTop) || ((_c = (_b = window.document.getElementById(actualColumn)) === null || _b === void 0 ? void 0 : _b.offsetParent) === null || _c === void 0 ? void 0 : _c.offsetTop) || 0;
            var left = (((_d = window.document.getElementById(actualColumn)) === null || _d === void 0 ? void 0 : _d.offsetLeft) || 0) + (((_e = window.document.getElementById(actualColumn)) === null || _e === void 0 ? void 0 : _e.offsetWidth) || 0) - columnHeaderMenuWidth;
            var minLeft = ((_f = window.document.getElementById('datatable')) === null || _f === void 0 ? void 0 : _f.offsetLeft) || 0;
            var maxLeft = (((_g = window.document.getElementById('datatable')) === null || _g === void 0 ? void 0 : _g.offsetLeft) || 0) + (((_h = window.document.getElementById('datatable')) === null || _h === void 0 ? void 0 : _h.offsetWidth) || 0);
            return {
                top: top_1 + 50,
                left: (left + minLeft) > minLeft
                    ? ((left + minLeft + columnHeaderMenuWidth) > maxLeft
                        ? (maxLeft - columnHeaderMenuWidth)
                        : (left + minLeft))
                    : minLeft,
            };
        }
    };
    var getSortable = function (column) {
        var columnSchema = entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.columns.find(function (col) { return col.name === column; });
        var sortable = (columnSchema === null || columnSchema === void 0 ? void 0 : columnSchema.sortable) || false;
        return sortable;
    };
    var getPinnedPosition = function () {
        var position;
        var pinPosition = 0;
        storedEntityColumns.map(function (col, index) {
            if (col.name === actualColumn) {
                pinPosition = index;
                if (!col.pinned) {
                    position = undefined;
                }
                else {
                    position = commonTypes_1.PinPosition.left;
                }
            }
        });
        if (storedEntityColumns[pinPosition].pinned) {
            storedEntityColumns.map(function (col, index) {
                if (index < pinPosition && !col.pinned) {
                    position = commonTypes_1.PinPosition.right;
                }
            });
        }
        return position;
    };
    var getManageColumnsPosition = function () {
        var _a, _b, _c, _d;
        if (actualColumn) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            var top_2 = ((_a = window.document.getElementById(actualColumn)) === null || _a === void 0 ? void 0 : _a.offsetTop) || ((_c = (_b = window.document.getElementById(actualColumn)) === null || _b === void 0 ? void 0 : _b.offsetParent) === null || _c === void 0 ? void 0 : _c.offsetTop) || 0;
            var minLeft = (((_d = window.document.getElementById('datatable')) === null || _d === void 0 ? void 0 : _d.offsetLeft) || 0);
            if (savedManagedColumnTop) {
                top_2 = savedManagedColumnTop;
            }
            else {
                setSavedManagedColumnTop(top_2);
            }
            return { top: top_2 + 50, left: minLeft };
        }
    };
    var countVisibleColumns = function () {
        var counter = 0;
        var cols = (crudeSchema && getCrudeEntityColumns_1.default(configurableTableLicense, crudeConfig, crudeSchema, entity)) || [];
        cols.map(function (elem) {
            if (!elem.hideInTableView) {
                counter += 1;
            }
        });
        return counter;
    };
    // Template Snippets
    var MenuIcon = function (columnName) {
        return (react_1.default.createElement(material_1.Tooltip, { title: react_1.default.createElement(react_1.default.Fragment, null, t('crude:settings')), enterDelay: 300 },
            react_1.default.createElement(MoreVert_1.default, { id: 'menuOpener', className: classes.moreIcon, onClick: function () {
                    columnName ? openColumnHeaderMenu(columnName) : setShowManageColumns(true);
                } })));
    };
    var columnLabels = (_b = (_a = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _a === void 0 ? void 0 : _a.entity[entity]) === null || _b === void 0 ? void 0 : _b.columns;
    return (react_1.default.createElement(system_1.Box, null,
        (props.treeViewLevel !== 0 &&
            dataDisplayMode !== commonTypes_1.DataDisplayMode.edit &&
            props.dataViewType !== commonTypes_1.DataViewType.referenceView) &&
            react_1.default.createElement(material_1.Grid, { container: true, sx: {
                    padding: '10px',
                    borderBottom: "2px solid " + theme.palette.grey.A200,
                    backgroundColor: theme.palette.background.paper,
                } },
                react_1.default.createElement(material_1.Grid, { item: true, xs: 11 },
                    react_1.default.createElement(material_1.Typography, { variant: 'subtitle1' },
                        react_1.default.createElement("b", null, dataEntries + " " + (((_d = (_c = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _c === void 0 ? void 0 : _c.entity[entity]) === null || _d === void 0 ? void 0 : _d.title) || props.entity) + " " + (dataEntries === 1 ? t('crude:entry') : dataEntries ? t('crude:entries') + " " + t('crude:of') + " " + data.totalElements : '')))),
                react_1.default.createElement(material_1.Grid, { item: true, xs: 1 },
                    react_1.default.createElement(AddButtonComponent_1.default, { display: props.treeViewLevel > 0, onClick: function () { return dispatch(crude_actions_1.setShowDialog(true)); } }))),
        react_1.default.createElement("div", null,
            react_1.default.createElement(material_1.TableContainer, { id: 'datatable' },
                react_1.default.createElement(material_1.Table, { size: 'small', className: classes.table, ref: tableRef },
                    props.dataViewType !== commonTypes_1.DataViewType.referenceView &&
                        react_1.default.createElement(material_1.TableHead, null,
                            react_1.default.createElement(material_1.TableRow, { style: { backgroundColor: theme.palette.background.default } }, countVisibleColumns() === 0
                                ? (react_1.default.createElement(react_1.default.Fragment, null, configurableTableLicense && props.treeViewLevel === 0 &&
                                    react_1.default.createElement(material_1.TableCell, null, MenuIcon())))
                                : (react_1.default.createElement(react_1.default.Fragment, null,
                                    (entitySchema && entitySchema.treeViewIncomingReference && listLevelAvailable) &&
                                        react_1.default.createElement(material_1.TableCell, { className: "" + classes.cell, id: 'treeview', size: 'small', style: {
                                                borderBottom: '0px',
                                                backgroundColor: 'inherit',
                                                zIndex: 999,
                                                left: '0px',
                                                filter: 'brightness(95%)',
                                                position: 'sticky',
                                            }, width: 50 }),
                                    storedEntityColumns.map(function (column) {
                                        var _a, _b;
                                        if (!column.hideInTableView) {
                                            if (column.name !== 'crudeAction') {
                                                var sortable = getSortable(column.name);
                                                return (react_1.default.createElement(material_1.TableCell, { align: 'justify', id: column.name, key: "head-" + column.name, className: "" + classes.cell, style: entitySchema && column.pinned && props.treeViewLevel === 0 ? getPinPosition_1.default(storedEntityColumns, column.name, entitySchema, column.columnWidth ? column.columnWidth + "px" : 'auto') : { width: column.columnWidth ? column.columnWidth + "px" : 'auto', minWidth: column.columnWidth ? column.columnWidth + "px" : 'auto' } },
                                                    react_1.default.createElement(system_1.Box, { style: { position: 'relative', display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
                                                        react_1.default.createElement(system_1.Box, { draggable: configurableTableLicense && props.treeViewLevel === 0, onDragStart: onDragColumnStart, onDragOver: onDragColumnOver, onDragEnd: onDragColumnEnd, "data-id": column.name, className: classes.headerCell, style: { justifyContent: "" + (configurableTableLicense && column.align && column.align !== commonTypes_1.TableTextAlignment.left ? ("" + (column.align === commonTypes_1.TableTextAlignment.right ? 'flex-end' : 'center')) : 'space-between') } },
                                                            sortable
                                                                ? (react_1.default.createElement(material_1.Tooltip, { title: react_1.default.createElement(react_1.default.Fragment, null, t('crude:sort')), enterDelay: 300 },
                                                                    react_1.default.createElement(material_1.TableSortLabel, { color: 'primary', active: storedTableFilterSettings[entity][props.treeViewLevel] ? storedTableFilterSettings[entity][props.treeViewLevel].orderBy === column.name : getDefaultTableFilterSettings_1.default().orderBy === column.name, direction: storedTableFilterSettings[entity][props.treeViewLevel] ? storedTableFilterSettings[entity][props.treeViewLevel].order : getDefaultTableFilterSettings_1.default().order, className: 'sortLabel', hideSortIcon: true, onClick: function () {
                                                                            handleSortLabelClicked(column.name);
                                                                        } }, columnLabels
                                                                        ? ((_a = columnLabels[column.name]) === null || _a === void 0 ? void 0 : _a.title) || column.name
                                                                        : column.name)))
                                                                : (react_1.default.createElement("span", { style: { cursor: 'pointer' } }, columnLabels
                                                                    ? ((_b = columnLabels[column.name]) === null || _b === void 0 ? void 0 : _b.title) || column.name
                                                                    : column.name)),
                                                            configurableTableLicense && props.treeViewLevel === 0 &&
                                                                react_1.default.createElement(react_1.default.Fragment, null, MenuIcon(column.name))),
                                                        configurableTableLicense && props.treeViewLevel === 0 &&
                                                            react_1.default.createElement(system_1.Box, { className: classes.columnResizeHandle, draggable: configurableTableLicense, onDragStart: function (event) {
                                                                    setActualColumn(column.name);
                                                                    onResizeStart(event);
                                                                }, onDragEnd: function (event) {
                                                                    onResizeEnd(event);
                                                                } }, "|"))));
                                            }
                                            else {
                                                return (react_1.default.createElement(react_1.default.Fragment, null, countVisibleColumns() === 0 ? (react_1.default.createElement(material_1.TableCell, null)) : (react_1.default.createElement(react_1.default.Fragment, null, editLevelAvailable && (react_1.default.createElement(material_1.TableCell, { key: "head-" + column.name, draggable: configurableTableLicense && props.treeViewLevel === 0, onDragStart: onDragColumnStart, onDragOver: onDragColumnOver, onDragEnd: onDragColumnEnd, style: entitySchema && column.pinned ? getPinPosition_1.default(storedEntityColumns, column.name, entitySchema, column.columnWidth ? column.columnWidth + "px" : '80px') : {}, id: column.name, align: 'justify', className: "" + classes.cell, children: react_1.default.createElement(system_1.Box, { className: classes.headerCell },
                                                        react_1.default.createElement("span", { style: { cursor: 'pointer' } }, t('crude:actions')),
                                                        configurableTableLicense && props.treeViewLevel === 0 &&
                                                            react_1.default.createElement(react_1.default.Fragment, null, MenuIcon(column.name))) }))))));
                                            }
                                        }
                                    }))))),
                    react_1.default.createElement(material_1.TableBody, null,
                        props && dataEntries !== 0 && props.dataViewType !== commonTypes_1.DataViewType.referenceView && countVisibleColumns() > 0 && (data === null || data === void 0 ? void 0 : data.data.map(function (tableRowData, index) { return (react_1.default.createElement(DataTableRow_1.default, { key: "DataTableRow" + index + props.treeViewLevel, data: data, entity: entity, id: (entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.idColumn) && tableRowData[entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.idColumn], treeViewLevel: props.treeViewLevel, dataViewType: props.dataViewType, stickyCell: stickyCell, tableRef: tableRef, editView: function (view) { return props.editView && props.editView(view); }, reloadTableViewData: function () { return props.reloadTableViewData && props.reloadTableViewData(); } })); })),
                        dataEntries !== 0 && props.dataViewType === commonTypes_1.DataViewType.referenceView && props.referenceEntity &&
                            Object.keys(data.entityReferencePreviews[props.referenceEntity]).map(function (referenceKey) { return (react_1.default.createElement(material_1.TableRow, { key: "DataTableRow" + referenceKey, onClick: function () { return props.onSelectTableRow && props.onSelectTableRow(referenceKey, props.referenceEntity && data.entityReferencePreviews[props.referenceEntity][referenceKey]); } },
                                react_1.default.createElement(DataTableCell_1.default, { dataViewType: props.dataViewType, align: commonTypes_1.TableTextAlignment.left, entityColumns: storedEntityColumns, treeViewLevel: props.treeViewLevel, content: props.referenceEntity && data.entityReferencePreviews[props.referenceEntity][referenceKey], entity: props.referenceEntity, thumbnailData: props.data.thumbnailData, entityReferencePreviews: props.data.entityReferencePreviews, id: referenceKey }))); }),
                        (dataEntries === 0) &&
                            react_1.default.createElement(material_1.TableRow, { className: 'tableRow', key: 'emptyRow' },
                                react_1.default.createElement(material_1.TableCell, { colSpan: entitySchema && entitySchema.columns.length + 1, align: 'center', style: { borderBottom: '0px' } },
                                    t('crude:noContent'),
                                    storedTableFilterSettings.filter && Object.keys(storedTableFilterSettings.filter).length !== 0 &&
                                        t('crude:resetFilter'))),
                        react_1.default.createElement(material_1.TableRow, null)))),
            data && countVisibleColumns() > 0 &&
                react_1.default.createElement(material_1.TablePagination, { component: 'div', count: data && data.totalElements, rowsPerPageOptions: props.dataViewType === commonTypes_1.DataViewType.referenceView ? [] : rowsPerPageOptions, rowsPerPage: storedTableFilterSettings[entity][props.treeViewLevel] ? storedTableFilterSettings[entity][props.treeViewLevel].pageSize : getDefaultTableFilterSettings_1.default().pageSize, page: storedTableFilterSettings[entity][props.treeViewLevel] ? storedTableFilterSettings[entity][props.treeViewLevel].page : getDefaultTableFilterSettings_1.default().page, backIconButtonProps: {
                        'aria-label': "" + t('crude:lastPage'),
                    }, nextIconButtonProps: {
                        'aria-label': "" + t('crude:nextPage'),
                    }, onPageChange: handleChangePage, onRowsPerPageChange: handleChangePageSize }),
            (data && (data.totalElements <= (storedTableFilterSettings[entity][props.treeViewLevel] ? storedTableFilterSettings[entity][props.treeViewLevel].pageSize : getDefaultTableFilterSettings_1.default().pageSize))) &&
                react_1.default.createElement("div", null)),
        showManageColumns &&
            react_1.default.createElement(material_1.ClickAwayListener, { onClickAway: function (event) {
                    setShowManageColumns(false);
                } },
                react_1.default.createElement(system_1.Box, { className: classes.manageColumnMenu, style: getManageColumnsPosition(), id: 'manageColumnMenu' },
                    react_1.default.createElement(material_1.Paper, { style: { padding: '14px' } },
                        react_1.default.createElement(material_1.TextField, { autoFocus: true, label: t('crude:searchColumn'), name: 'name', color: 'primary', autoComplete: 'off', variant: 'standard', sx: {
                                pr: 2,
                                width: '100%',
                                paddingRight: '0px',
                            }, InputProps: {
                                endAdornment: (react_1.default.createElement(material_1.InputAdornment, { position: 'end' },
                                    react_1.default.createElement(Search_1.default, null))),
                            }, InputLabelProps: {
                                shrink: true,
                            }, onChange: (function (event) {
                                setColumnSearch(event.target.value);
                            }), size: 'small' }),
                        react_1.default.createElement(system_1.Box, { sx: { margin: '15px 0' } },
                            getPagedFilteredManageColumns().map(function (column) {
                                var _a;
                                return react_1.default.createElement(system_1.Box, { key: column.name, className: classes.manageColumnsBox },
                                    react_1.default.createElement(SwitchComponent_1.default, { size: 'small', checked: !column.hideInTableView, onChange: function (checked) {
                                            var _a;
                                            var newTabs = (_a = crudeConfig.tabs) === null || _a === void 0 ? void 0 : _a.map(function (elem) {
                                                var tab = __assign({}, elem);
                                                if (tab.entity === entity) {
                                                    var newCols = (crudeSchema && getCrudeEntityColumns_1.default(configurableTableLicense, crudeConfig, crudeSchema, entity)) || [];
                                                    var cols = newCols.map(function (elem) {
                                                        var col = __assign({}, elem);
                                                        if (col.name === column.name) {
                                                            col.hideInTableView = !checked;
                                                        }
                                                        return col;
                                                    });
                                                    tab.columns = cols;
                                                }
                                                return tab;
                                            });
                                            dispatch(crudeActions.setCrudeConfiguration(__assign(__assign({}, crudeConfig), { tabs: newTabs })));
                                        }, label: column.name === 'crudeAction'
                                            ? t('crude:actions')
                                            : (columnLabels
                                                ? ((_a = columnLabels[column.name]) === null || _a === void 0 ? void 0 : _a.title) || column.name
                                                : column.name) }));
                            }),
                            getFilteredManageColumns().length > manageColumnPageSize &&
                                react_1.default.createElement(material_1.TablePagination, { component: 'div', rowsPerPageOptions: [], count: getFilteredManageColumns().length, rowsPerPage: manageColumnPageSize, page: manageColumnPage, backIconButtonProps: {
                                        'aria-label': "" + t('crude:lastPage'),
                                    }, nextIconButtonProps: {
                                        'aria-label': "" + t('crude:nextPage'),
                                    }, onPageChange: handleChangeManageColumnPage })),
                        react_1.default.createElement(system_1.Box, { sx: { display: 'flex', justifyContent: 'space-between' } },
                            react_1.default.createElement(ButtonComponent_1.default, { variant: 'text', onClick: function () {
                                    var _a;
                                    var newTabs = (_a = crudeConfig.tabs) === null || _a === void 0 ? void 0 : _a.map(function (elem) {
                                        var tab = __assign({}, elem);
                                        if (tab.entity === entity) {
                                            var newCols = (crudeSchema && getCrudeEntityColumns_1.default(configurableTableLicense, crudeConfig, crudeSchema, entity)) || [];
                                            var cols = newCols.map(function (elem) {
                                                var col = __assign({}, elem);
                                                col.hideInTableView = true;
                                                return col;
                                            });
                                            tab.columns = cols;
                                        }
                                        return tab;
                                    });
                                    dispatch(crudeActions.setCrudeConfiguration(__assign(__assign({}, crudeConfig), { tabs: newTabs })));
                                    setShowManageColumns(false);
                                }, text: t('crude:hideAll') }),
                            react_1.default.createElement(ButtonComponent_1.default, { variant: 'text', onClick: function () {
                                    var _a;
                                    var newTabs = (_a = crudeConfig.tabs) === null || _a === void 0 ? void 0 : _a.map(function (elem) {
                                        var tab = __assign({}, elem);
                                        if (tab.entity === entity) {
                                            var newCols = (crudeSchema && getCrudeEntityColumns_1.default(configurableTableLicense, crudeConfig, crudeSchema, entity)) || [];
                                            var cols = newCols.map(function (elem) {
                                                var col = __assign({}, elem);
                                                col.hideInTableView = false;
                                                return col;
                                            });
                                            tab.columns = cols;
                                        }
                                        return tab;
                                    });
                                    dispatch(crudeActions.setCrudeConfiguration(__assign(__assign({}, crudeConfig), { tabs: newTabs })));
                                    setShowManageColumns(false);
                                }, text: t('crude:showAll') }))))),
        showColumnHeaderMenu &&
            react_1.default.createElement(material_1.ClickAwayListener, { onClickAway: function (event) {
                    setShowColumnHeaderMenu(false);
                } },
                react_1.default.createElement(system_1.Box, { id: 'columnHeaderMenu', className: classes.columnHeaderMenu, style: getActualHeaderColumnPosition() },
                    react_1.default.createElement(material_1.Paper, { className: classes.paper },
                        react_1.default.createElement(material_1.List, null,
                            react_1.default.createElement(material_1.ListItem, { className: classes.columnHeaderMenuEntry + " " + (!getSortable(actualColumn) && classes.disabledHeaderMenuEntry), onClick: function () { return sortAscActualColumn(); } },
                                react_1.default.createElement("div", { className: classes.columnHeaderMenuEntryIcon },
                                    react_1.default.createElement(ArrowUpward_1.default, null)),
                                react_1.default.createElement("div", { className: classes.columnHeaderMenuEntryText }, t('crude:sortAsc'))),
                            react_1.default.createElement(material_1.ListItem, { className: classes.columnHeaderMenuEntry + " " + (!getSortable(actualColumn) && classes.disabledHeaderMenuEntry), onClick: function () { return sortDescActualColumn(); } },
                                react_1.default.createElement("div", { className: classes.columnHeaderMenuEntryIcon },
                                    react_1.default.createElement(ArrowDownward_1.default, null)),
                                react_1.default.createElement("div", { className: classes.columnHeaderMenuEntryText }, t('crude:sortDesc'))),
                            react_1.default.createElement(material_1.Divider, null),
                            react_1.default.createElement(material_1.ListItem, { className: classes.columnHeaderMenuEntry + " " + (getPinnedPosition() === commonTypes_1.PinPosition.left && classes.disabledHeaderMenuEntry), onClick: function () { return getPinnedPosition() !== commonTypes_1.PinPosition.left && pinLeftActualColumn(); } },
                                react_1.default.createElement("div", { className: classes.columnHeaderMenuEntryIcon },
                                    react_1.default.createElement(PushPin_1.default, { style: { transform: 'rotate(30deg)' } })),
                                react_1.default.createElement("div", { className: classes.columnHeaderMenuEntryText }, t('crude:pinToLeft'))),
                            react_1.default.createElement(material_1.ListItem, { className: classes.columnHeaderMenuEntry + " " + (getPinnedPosition() === commonTypes_1.PinPosition.right && classes.disabledHeaderMenuEntry), onClick: function () { return getPinnedPosition() !== commonTypes_1.PinPosition.right && pinRightActualColumn(); } },
                                react_1.default.createElement("div", { className: classes.columnHeaderMenuEntryIcon },
                                    react_1.default.createElement(PushPin_1.default, { style: { transform: 'rotate(-30deg)' } })),
                                react_1.default.createElement("div", { className: classes.columnHeaderMenuEntryText }, t('crude:pinToRight'))),
                            react_1.default.createElement(material_1.Divider, null),
                            react_1.default.createElement(material_1.ListItem, { className: classes.columnHeaderMenuEntry, onClick: function () { return hideActualColumn(); } },
                                react_1.default.createElement("div", { className: classes.columnHeaderMenuEntryIcon },
                                    react_1.default.createElement(VisibilityOff_1.default, null)),
                                react_1.default.createElement("div", { className: classes.columnHeaderMenuEntryText }, t('crude:hideColumn'))),
                            react_1.default.createElement(material_1.ListItem, { className: classes.columnHeaderMenuEntry, onClick: function () {
                                    setShowColumnHeaderMenu(false);
                                    setShowManageColumns(true);
                                } },
                                react_1.default.createElement("div", { className: classes.columnHeaderMenuEntryIcon },
                                    react_1.default.createElement(ViewWeek_1.default, null)),
                                react_1.default.createElement("div", { className: classes.columnHeaderMenuEntryText }, t('crude:manageColumns'))))))),
        props.treeViewLevel > 0 &&
            react_1.default.createElement(CrudeDialogComponent_1.default, { onClose: function () {
                    dispatch(crude_actions_1.setShowDialog(false));
                }, content: react_1.default.createElement(DataEditView_1.default, { dataViewType: commonTypes_1.DataViewType.simpleView, entity: props.entity, embeddingEntityFilter: props.embeddingEntityFilter, treeViewLevel: props.treeViewLevel + 1, hideBackButton: true, showInPopup: true }) })));
};
exports.default = DataTable;
